import {
  ATDividedList,
  ATDividedListItem,
  ATSelectionTile,
} from 'components/common/beacon/beaconRegistration';
import React from 'react';
import { IExternalAccount } from 'src/api/atv/atvApi.types';
import { TransferTypeValue } from 'utils/constants';
import { Orientations } from '@trp-beacon-ui-kit/foundation/dist/_common/types/orientations';

interface AccountDetailsProps {
  account: IExternalAccount;
  handleSelectTransferType: (type: TransferTypeValue) => void;
  transferType: TransferTypeValue;
}

const accountDetails: React.FC<AccountDetailsProps> = ({
  account,
  handleSelectTransferType,
  transferType,
}) => (
  <div className="external-account b-grid b-padding--micro--jumbo custom-style">
    <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:12-col b-lg:12-col">
      <ATDividedList className="data-list" orientation={Orientations.Vertical}>
        <ATDividedListItem>
          <span slot="supporting-text">Account number</span>
          <span slot="data-point">{account.accountNumber}</span>
        </ATDividedListItem>
        <ATDividedListItem>
          <span slot="supporting-text">Owner(s)</span>
          <div slot="data-point">
            {account?.holder?.map((holder: any) =>
              holder ? <div key={holder.id}>{holder.name?.fullName ?? ''}</div> : null,
            )}
          </div>
        </ATDividedListItem>
      </ATDividedList>
      <div className="b-typography-sans-serif--body--50 b-font-weight-bold certificate-deposit-group">
        Do you want to make a full or partial transfer of your assets?
      </div>
      <div className="b-grid">
        <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:6-col b-lg:6-col certificate-deposit-group">
          <ATSelectionTile className="external-account">
            <label slot="label" htmlFor={`full-transfer${account.id}`}>
              {TransferTypeValue.FullTransfer}
            </label>
            <input
              type="radio"
              id={'full-transfer' + account.id}
              name="transfer-type"
              checked={transferType === TransferTypeValue.FullTransfer}
              onChange={() => handleSelectTransferType(TransferTypeValue.FullTransfer)}
            />
          </ATSelectionTile>
          <ATSelectionTile className="external-account">
            <label slot="label" htmlFor={`partial-transfer${account.id}`}>
              {TransferTypeValue.PartialTransfer}
            </label>
            <input
              type="radio"
              id={'partial-transfer' + account.id}
              name="transfer-type"
              checked={transferType === TransferTypeValue.PartialTransfer}
              onChange={() => handleSelectTransferType(TransferTypeValue.PartialTransfer)}
            />
          </ATSelectionTile>
        </div>
      </div>
    </div>
  </div>
);

export default accountDetails;
